// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IMessageAudienceKindEnumDto } from './message-audience-kind-enum-dto.g';
import { IAffiliationEnumDto } from './affiliation-enum-dto.g';

export const messageAudienceDto = {
    kind: 'kind',
    guid: 'guid',
    name: 'name',
    affiliation: 'affiliation',
    organisation_Name: 'organisation_Name',
    memberCount: 'memberCount',
} as const;

export type TMessageAudienceDto = (typeof messageAudienceDto)[keyof typeof messageAudienceDto];

export interface IMessageAudienceDto {
    [messageAudienceDto.kind]: IMessageAudienceKindEnumDto | null;
    [messageAudienceDto.guid]: string | null;
    [messageAudienceDto.name]: string | null;
    [messageAudienceDto.affiliation]: IAffiliationEnumDto | null;
    [messageAudienceDto.organisation_Name]: string | null;
    [messageAudienceDto.memberCount]: number | null;
}

export class MessageAudienceDto
    implements IMessageAudienceDto
{
    [messageAudienceDto.kind]: IMessageAudienceKindEnumDto | null = null;
    [messageAudienceDto.guid]: string | null = null;
    [messageAudienceDto.name]: string | null = null;
    [messageAudienceDto.affiliation]: IAffiliationEnumDto | null = null;
    [messageAudienceDto.organisation_Name]: string | null = null;
    [messageAudienceDto.memberCount]: number | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IMessageAudienceData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[messageAudienceDto.guid] = modelData[messageaudienceData.guid];
    }

    static create(modelData?: any | null): IMessageAudienceDto | null {
        return modelData ? new MessageAudienceDto(modelData) : null;
    }
}
